import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class CorsiUtentiService {
  
    static getCorsiUtenteByToken = () => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi-utenti/findPurchasedByUserId`;
            ApiService.getRequest(resolve, reject, url)
        });
     }

    static assignCourseToUser = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi-utenti/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
     }

     static deleteCorsoUtenti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi-utenti/delete`;
            ApiService.delete(resolve, reject, url, data)
        });
    }

     static updateCorsoUtenti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi-utenti/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
    }

     static getCorsoUtentiByIdCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/corsi-utenti/findUtentiByIdCorso`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

}